
import { redirect } from 'react-router-dom'

const errorHandling = {

    catchHandler: function (err, callback) {
        switch (err.response && err.response.status) {
          case 0:
            // this.showSAlert('Remote server can not be reachable', 'error', callback);
            break
          case 400:
            // this.showSAlert(err.response.data.message, 'error', callback);
            break;
          case 401:
            if (!err.response.data.detail) {
              localStorage.clear();
              let REACT_APP_SSO_ROOT_URL = process.env.REACT_APP_SSO_ROOT_URL
              let REACT_APP_FRONT_ROOT_URL = process.env.REACT_APP_FRONT_ROOT_URL
              let REACT_APP_PROJECT_SLUG = process.env.REACT_APP_PROJECT_SLUG
              window.location.href = REACT_APP_SSO_ROOT_URL + "/login?redirect=" + REACT_APP_FRONT_ROOT_URL + "&slug=" + REACT_APP_PROJECT_SLUG;
              // return redirect("/");
            }
            break;
          case 404:
            // this.showSAlert(err.response.data.message, 'error', callback);
            break;
          case 409:
            //
            // this.showSAlert(err.response.data.message, 'error', callback);
            break;
          default:
            break;
        }
      },
}

export default errorHandling